// import React, { useEffect, useState } from 'react';
// import { Modal } from 'react-bootstrap';
// import { useSelector, useDispatch } from 'react-redux';
// import { RootState } from '../../../../setup';
// import { setLiveStream, setSnapShot } from '../../../redux/WebSocketSlice';

// const WebSocketModal: React.FC = () => {
//     const dispatch = useDispatch();
//     const liveStream = useSelector((state: RootState) => state.webSocket.liveStream);
//     const snapShot = useSelector((state: RootState) => state.webSocket.snapShot);
//     const [show, setShow] = useState(false);
//     const [content, setContent] = useState<React.ReactNode>(null);

//     useEffect(() => {
//         if (liveStream) {
//             setContent(
//                 <div>
//                     <h5>Live Stream</h5>
//                     <img src={liveStream} alt="LiveStream" style={{ width: '100%' }} />
//                 </div>
//             );
//             setShow(true);
//         } else if (snapShot) {
//             setContent(
//                 <div>
//                     <h5>Snapshot</h5>
//                     <img src={snapShot} alt="Snapshot" style={{ width: '100%' }} />
//                 </div>
//             );
//             setShow(true);
//         }
//     }, [liveStream, snapShot]);

//     const handleClose = () => {
//         setShow(false);
//         if (liveStream) {
//             dispatch(setLiveStream(null));
//         }
//         if (snapShot) {
//             dispatch(setSnapShot(null));
//         }
//     };

//     return (
//         <Modal show={show} onHide={handleClose} centered>
//             <Modal.Header closeButton>
//                 <Modal.Title>WebSocket Event</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {content}
//             </Modal.Body>
//             {/* <Modal.Footer>
//                 <Button variant="secondary" onClick={handleClose}>
//                     Close
//                 </Button>
//             </Modal.Footer> */}
//         </Modal>
//     );
// };

// export default WebSocketModal;

import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useSelector, useDispatch, shallowEqual} from 'react-redux'
import {RootState} from '../../../../setup'
import {
  setCommandStatus,
  setLiveStream,
  setRecordedVideo,
  setSettingFile,
  setSnapShots,
  toggleLiveStream,
} from '../../../redux/WebSocketSlice'
import {apiGetCamSnapShot, apiReqLiveStreaming, apiSetSetting} from '../../../redux/api'
import * as devices from '../../../redux/DevicesRedux'
import {ShimmerImage} from '../../../components/ShimmerImage'
import _ from 'lodash'
import moment from 'moment'
// import LoadingText from '../../../components/LoadingText'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
// import store from '../../../../setup/redux/Store'
import ProgressBar from '../../../components/ProgressBar'
import ShareLink from '../../../components/share-link/ShareLink'

const WebSocketModal: React.FC = () => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const commandStatus: any = useSelector((state: RootState) => state.webSocket.commandStatus)

  const liveStream = useSelector((state: RootState) => state.webSocket.liveStream)
  const snapShots = useSelector((state: RootState) => state.webSocket.snapShots)
  const recordedVideo = useSelector((state: RootState) => state.webSocket.recordedVideo)
  const settingFile = useSelector((state: RootState) => state.webSocket.settingFile)
  const isLiveStreamActive = useSelector((state: RootState) => state.webSocket.isLiveStreamActive)

  const selectedDevice: any = useSelector<RootState>(
    ({device}) => device.selectedDevice,
    shallowEqual
  )
  const [show, setShow] = useState(false)
  const [content, setContent] = useState<React.ReactNode>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [textAreaValue, setTextAreaValue] = useState<any>(null)
  const [saving, setSaving] = useState<boolean>(false)
  const [downloading, setDownloading] = useState<boolean>(false)
  const reqCamSnapShot = (device: any) => {
    resetData()

    dispatch(
      devices.actions.setSelectedDevice({
        ...device,
        RequestedTitle: 'MENU.SNAPSHOT',
        view: 'popup',
      })
    )
    let deviceId = device.DeviceId

    setIsLoading(true)
    let sessionId: any = localStorage.getItem('ssid')
    if (sessionId) {
      sessionId = atob(sessionId)
    }

    const query: any = {
      deviceId,
      sessionId,
    }

    const uploadSnapshot: any = {
      UploadSnapshot: {
        Channel: 255,
        Type: 0,
      },
    }

    apiGetCamSnapShot(query, uploadSnapshot)
      .then(({data}) => {
        setIsLoading(false)
      })
      .catch((e) => {
        setIsLoading(false)
      })
  }

  const reqLiveStream = (device: any, maxPlaySecond?: any) => {
    dispatch(
      devices.actions.setSelectedDevice({
        ...device,
        RequestedTitle: 'DEVICE.LIVE_STREAM',
        view: 'popup',
      })
    )
    let deviceId = device.DeviceId

    setIsLoading(true)
    let sessionId: any = localStorage.getItem('ssid')
    if (sessionId) {
      sessionId = atob(sessionId)
    }

    const query: any = {
      deviceId,
      sessionId,
    }

    setTimeout(() => {
      apiReqLiveStreaming(query, {
        // liveStreaming: {
        AudioChannel: 0,
        MaxPlaySecond: maxPlaySecond !== undefined ? maxPlaySecond : 60,
        VideoChannel: 255,
        VideoInterval: 1,
        WsUrl: '',
        // },
      })
        .then(({data}) => {
          setIsLoading(false)
        })
        .catch((error) => {
          setIsLoading(false)
        })
    }, 1000)
  }

  const handleTextChange = (event: any) => {
    setTextAreaValue(event.target.value)
  }

  const downloadMDT = (video: any) => {
    const baseUrl = 'https://cdn.vehiclets.com:440'
    const fileUrl = `${baseUrl}/${video.FileName}`

    const anchor = document.createElement('a')
    anchor.href = fileUrl
    anchor.download = video.FileName.split('/').pop()
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  }

  const saveSetting = (device: any, value: any) => {
    let sessionId: any = localStorage.getItem('ssid')
    if (sessionId) {
      sessionId = atob(sessionId)
    }

    let query = {
      deviceId: device.DeviceId,
      sessionId,
    }

    let requestBody = {
      DriverId: device.DriverId,
      SettingFile: btoa(value),
      VehicleNo: device.VehicleNo,
    }

    setSaving(true)

    const id = toast.loading(intl.formatMessage({id: 'TOAST.SAVING_SETTING'}))
    apiSetSetting(query, JSON.stringify(requestBody))
      .then(({data}) => {
        if (data.status == 200) {
          toast.update(id, {
            render: intl.formatMessage({id: 'TOAST.SETTING_SAVED_SUCCESSFULLY'}),
            type: 'success',
            isLoading: false,
          })
        } else {
          toast.update(id, {
            render: `${intl.formatMessage({id: 'TOAST.SETTING_COULD_NOT_BE_SAVED.THE_CLOUD_SERVICE_RESPONDED'})} : ${data.Message}`,
            type: 'error',
            isLoading: false,
          })
        }
        setSaving(false)
        setTimeout(() => {
          toast.dismiss(id)
        }, 5000)
      })
      .catch((res: any) => {
        toast.update(id, {
          render: intl.formatMessage({id: 'TOAST.SETTING_COULD_NOT_BE_SAVED'}) + '.',
          type: 'error',
          isLoading: false,
        })
        setSaving(false)
        setTimeout(() => {
          toast.dismiss(id)
        }, 5000)
      })
  }
  const downloadMP4 = async (video: any) => {
    setDownloading(true)
    const baseUrl = 'https://cdn.vehiclets.com:440'
    const fileUrl = `${baseUrl}/${video.FileName}`

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
      })

      if (!response.ok) {
        setDownloading(false)
        throw new Error(`Failed to fetch file: ${response.statusText}`)
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = video.FileName.split('/').pop() || 'download.mp4'
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      window.URL.revokeObjectURL(url)
      setDownloading(false)
    } catch (error) {
      setDownloading(false)
      console.error('Error downloading file:', error)
    }
  }
  useEffect(() => {
    if (liveStream && !_.isEmpty(liveStream)) {
      if (isLiveStreamActive) {
        setContent(
          <React.Fragment>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {liveStream.liveStream.map((liveStream: any, index: any) => (
                <div className='snapshot-image' key={index}>
                  <img
                    className='mb-5 rounded border border-gray-300'
                    src={liveStream}
                    alt={`Livestream ${index + 1}`}
                  />
                  {/* <span className="timestamp text-white">Waiting to stream</span> */}
                  <div className='live-timestamp d-flex gap-5 align-items-center'>
                    <span className='live'>{intl.formatMessage({id: 'BADGE.LIVE'})}</span>
                    <span className='livetimestamp text-white'>
                      {moment(liveStream.timestamp).format('YYYY-MM-DD, HH:mm:ss')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className='d-flex w-100 justify-content-end'>
              <button
                className='btn btn-danger btn-sm d-flex gap-1 align-items-center'
                onClick={(e) => {
                  e.stopPropagation()
                  dispatch(toggleLiveStream(false))
                  reqLiveStream(selectedDevice, 0)
                }}
              >
                <i className='fa fa-stop'></i>
                {intl.formatMessage({id: 'BUTTON.STOP_STREAM'})}
              </button>
            </div>
          </React.Fragment>
        )
      } else {
        setContent(
          <React.Fragment>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {liveStream.liveStream.map((liveStream: any, index: any) => (
                <div className='snapshot-image' key={index}>
                  <img
                    className='mb-5 rounded border border-gray-300'
                    src={liveStream}
                    alt={`Livestream ${index + 1}`}
                  />
                  {/* <span className="timestamp text-white">Waiting to stream</span> */}
                  <div className='live-timestamp d-flex gap-5 align-items-center'>
                    {/* <span className='live'>
                      {intl.formatMessage({ id: "BADGE.LIVE" })}
                    </span> */}
                    <span className='livetimestamp text-white'>
                      {moment(liveStream.timestamp).format('YYYY-MM-DD, HH:mm:ss')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className='d-flex w-100 justify-content-end'>
              {!isLiveStreamActive && (
                <button
                  className='btn btn-success btn-sm d-flex gap-1 align-items-center'
                  onClick={(e) => {
                    e.stopPropagation()
                    dispatch(toggleLiveStream(true))
                    dispatch(setLiveStream({}))
                    reqLiveStream(selectedDevice)
                  }}
                >
                  <i className='fa fa-play'></i>
                  {intl.formatMessage({id: 'BUTTON.START_STREAM'})}
                </button>
              )}
            </div>
          </React.Fragment>
        )
      }

      setIsLoading(false)
    } else if (snapShots && !_.isEmpty(snapShots)) {
      setContent(
        <React.Fragment>
          <div style={{display: 'flex', flexWrap: 'wrap'}}>
            {snapShots.snapShots.map((snapshot: any, index: any) => (
              <div className='snapshot-image' key={index}>
                <a
                  href={snapshot}
                  download={`${selectedDevice.VehicleNo.replace(/\s+/g, '')}-snapshot-${moment(snapShots.timestamp).format('YYMMDD')}-${moment(snapShots.timestamp).format('HHmmss')}`}
                  onClick={(e) => {
                    e.preventDefault()
                  }}
                  onAuxClick={(e) => {
                    if (e.button === 1) {
                      e.preventDefault()
                    }
                  }}
                >
                  <img
                    className='rounded border border-gray-300'
                    src={snapshot}
                    alt={`Snapshot ${index + 1}`}
                  />
                </a>
                <span className='timestamp text-white'>
                  {moment(snapShots.timestamp).format('YYYY-MM-DD, HH:mm:ss')}
                </span>
              </div>
            ))}
          </div>
          <div className='d-flex w-100 justify-content-end'>
            <button
              className='btn btn-primary btn-sm d-flex gap-1 align-items-center'
              onClick={(e) => {
                e.stopPropagation()
                reqCamSnapShot(selectedDevice)
              }}
            >
              <i className='bi bi-arrow-repeat' style={{fontSize: '17px'}}></i>
              {intl.formatMessage({id: 'BUTTON.NEW_SNAPSHOT'})}
            </button>
          </div>
        </React.Fragment>
      )

      setIsLoading(false)
    } else if (recordedVideo && !_.isEmpty(recordedVideo)) {
      if (recordedVideo.recordedVideo.Type == 'MDT') {
        setContent(
          <React.Fragment>
            <div
              className='fw-normal mb-2 d-flex align-items-center justify-content-between'
              style={{fontSize: 12, lineHeight: '18px', gap: '12px'}}
            >
              <div>
                <span className='fw-bolder'>
                  {intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}
                </span>
                :
                <span className='fw-bold'>
                  {selectedDevice.TimeRange && <>&nbsp;{selectedDevice.TimeRange}</>}
                </span>
              </div>
              <div className='video-links'>
                <ShareLink className={'share-link'} selectedDevice={selectedDevice} />
                <div className='download-video'>
                  {downloading ? (
                    <span className='spinner-border spinner-border-sm text-primary align-middle'></span>
                  ) : (
                    <KTSVG
                      path='/media/icons/duotone/General/Requestfile.svg'
                      className='request-file'
                    />
                  )}
                  <span
                    className='link-primary text-break text-underline fw-bolder'
                    onClick={(e) => {
                      e.stopPropagation()
                      downloadMDT(recordedVideo.recordedVideo)
                    }}
                  >
                    {intl.formatMessage({id: 'DEVICE.DOWNLOAD_MDT-VIDEO'})}
                  </span>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
      } else {
        setContent(
          <React.Fragment>
            <div
              className='fw-normal mb-2 d-flex align-items-center justify-content-between'
              style={{fontSize: 12, lineHeight: '18px'}}
            >
              <div>
                <span className='fw-bolder'>
                  {intl.formatMessage({id: 'DEVICE.RECORDED_VIDEO'})}
                </span>
                :{' '}
                <span className='fw-bold'>
                  {selectedDevice.TimeRange && <>{selectedDevice.TimeRange}</>}
                </span>
              </div>
              <div className='video-links'>
                <ShareLink className={'share-link'} selectedDevice={selectedDevice} />
                <div className='download-video'>
                  {downloading ? (
                    <span className='spinner-border spinner-border-sm text-primary align-middle'></span>
                  ) : (
                    <KTSVG
                      path='/media/icons/duotone/General/Requestfile.svg'
                      className='request-file'
                    />
                  )}
                  <span
                    className='link-primary text-break text-underline fw-bolder'
                    onClick={(e) => {
                      e.stopPropagation()
                      downloadMP4(recordedVideo.recordedVideo)
                    }}
                  >
                    {intl.formatMessage({id: 'DEVICE.DOWNLOAD_MP4-VIDEO'})}
                  </span>
                </div>
              </div>
            </div>

            <div className='responsive-video-container'>
              <video
                src={`https://cdn.vehiclets.com:440/${recordedVideo.recordedVideo.FileName}`}
                controls
                className='responsive-video'
              >
                {intl.formatMessage({id: 'TOOLTIP.YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG'})}.
              </video>
            </div>
          </React.Fragment>
        )
      }

      setIsLoading(false)
    } else if (settingFile && !_.isEmpty(settingFile)) {
      let settingValue: any
      if (
        settingFile.settingFile &&
        settingFile.settingFile.Body &&
        settingFile.settingFile.Body.SettingFile
      ) {
        settingValue = atob(settingFile.settingFile.Body.SettingFile)
        setTextAreaValue(settingValue)
      }
      setContent(<React.Fragment></React.Fragment>)
      setIsLoading(false)
    } else if (isLoading) {
      setContent(
        // <ShimmerImage width={480} height={320}>
        //   {/* <LoadingText text='LOADING...' /> */}
        //   <span className='spinner-border text-primary align-middle h-100px w-100px'></span>
        // </ShimmerImage>
        <ShimmerImage width={480} height={320}>
          <img
            style={{maxWidth: 480, maxHeight: 320}}
            className=''
            src={toAbsoluteUrl('/media/svg/general/camera-placeholder.svg')}
            alt='camera-placeholder'
          />
          <span className='spinner-border requesting-spinner align-middle text-primary position-absolute'></span>
          {selectedDevice && selectedDevice.RequestedTitle == 'DEVICE.RECORDED_VIDEO' && (
            <ProgressBar title={intl.formatMessage({id: 'TOAST.REQUESTING_VIDEO'})} />
          )}
        </ShimmerImage>
      )
    }
  }, [liveStream, snapShots, recordedVideo, settingFile, isLoading, isLiveStreamActive])

  React.useEffect(() => {
    if (selectedDevice && !_.isEmpty(selectedDevice) && selectedDevice.view == 'popup') {
      setShow(true)
      setIsLoading(true)
    }
  }, [selectedDevice])

  React.useEffect(() => {
    if (commandStatus) {
      if (commandStatus.ResCode == 3) {
        const toastId = 'command-error'
        if (!toast.isActive(toastId)) {
          toast.error(commandStatus.ResStr, {toastId})
        }
        // setIsLoading(false)
        handleClose()
        // dispatch(devices.actions.setSelectedDevice({}))
        // dispatch(setCommandStatus(null))
      }
    }
  }, [commandStatus])

  const handleClose = () => {
    resetData()
    setShow(false)
  }

  const resetData = () => {
    setIsLoading(false)

    if (liveStream && !_.isEmpty(liveStream)) {
      dispatch(toggleLiveStream(false))
      dispatch(setLiveStream({}))
      if (isLiveStreamActive) {
        reqLiveStream(selectedDevice, 0)
      }
    }
    if (snapShots && !_.isEmpty(snapShots)) {
      dispatch(setSnapShots({}))
    }
    if (recordedVideo && !_.isEmpty(recordedVideo)) {
      dispatch(setRecordedVideo({}))
      dispatch(setCommandStatus(null))
    }
    if (commandStatus && !_.isEmpty(commandStatus)) {
      dispatch(setCommandStatus(null))
    }
    if (settingFile && !_.isEmpty(settingFile)) {
      dispatch(setSettingFile({}))
    }
    if (selectedDevice && !_.isEmpty(selectedDevice)) {
      dispatch(devices.actions.setSelectedDevice({}))
    }
  }

  return (
    <Modal
      className={`web-socket-modal ${recordedVideo && !_.isEmpty(recordedVideo) ? 'video-player' : ''} ${settingFile && !_.isEmpty(settingFile) ? 'setting-view' : ''}`}
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Body>
        <div className='d-flex w-100 align-items-center justify-content-between mb-5'>
          <h1 className='text-primary d-flex gap-3 align-items-center'>
            <i
              className={`${
                selectedDevice.RequestedTitle?.toLowerCase().includes('setting')
                  ? 'bi bi-gear-fill'
                  : selectedDevice.RequestedTitle?.toLowerCase().includes('video') ||
                      selectedDevice.RequestedTitle?.toLowerCase().includes('stream')
                    ? 'fa fa-video'
                    : 'fa fa-camera'
              } fs-1`}
              style={{color: 'var(--bs-primary)'}}
            ></i>
            {selectedDevice?.RequestedTitle && (
              <>{intl.formatMessage({id: selectedDevice?.RequestedTitle})}</>
            )}
          </h1>
          <button className='btn btn-link p-0' type='button' onClick={handleClose}>
            <i
              className='fa fa-times-thin fa-2x'
              aria-hidden='true'
              style={{fontSize: '2em', padding: 0, verticalAlign: 'unset'}}
            ></i>
          </button>
        </div>
        <div className='d-flex gap-5 align-items-center mb-5'>
          <label className='form-label fs-6 text-dark m-0'>{selectedDevice.VehicleNo}</label>
          <label className='form-label fs-6 m-0 text-gray-600'>{selectedDevice.DeviceId}</label>
          <label className='form-label fs-6 text-gray-600 m-0'>
            {selectedDevice.Active == true ? (
              <div className='d-flex align-items-center'>
                <span className={'badge badge-success badge-circle w-15px h-15px mr-4'}></span>
                {intl.formatMessage({id: 'DEVICE.ONLINE'})}
              </div>
            ) : (
              <div className='d-flex align-items-center'>
                <span className={'badge badge-danger badge-circle w-15px h-15px mr-4'}></span>
                {selectedDevice.LastOnline}
              </div>
            )}
          </label>
        </div>
        <div className='line-break w-100 my-5' style={{backgroundColor: '#EFF2F5', height: 1}} />

        {content}

        {!isLoading && settingFile && !_.isEmpty(settingFile) && (
          <React.Fragment>
            <div className='setting-container'>
              <textarea
                className='form-control form-control-solid w-100'
                value={textAreaValue || ''}
                rows={25}
                cols={80}
                onChange={(e) => handleTextChange(e)}
                style={{marginTop: '10px', width: '100%'}}
              />
            </div>
            <div className='d-flex w-100 justify-content-end mt-5 gap-3'>
              <button
                className='btn btn-primary btn-sm'
                onClick={(e) => {
                  e.stopPropagation()
                  saveSetting(selectedDevice, textAreaValue)
                }}
                disabled={saving}
              >
                {intl.formatMessage({id: 'BUTTON.SAVE'})}
                {saving && (
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                )}
              </button>
              <button
                className='btn btn-secondary btn-sm'
                onClick={(e) => {
                  e.stopPropagation()
                  handleClose()
                }}
              >
                {intl.formatMessage({id: 'BUTTON.CANCEL'})}
              </button>
            </div>
          </React.Fragment>
        )}
      </Modal.Body>
      {/* <Modal.Header>
                <Modal.Title>WebSocket Event</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body> */}
      {/* <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer> */}
    </Modal>
  )
}

export default WebSocketModal
